import { Link, useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SiteHeader />
      <main className="flex-1 flex items-center justify-center px-4 pt-16 md:pt-20">
        <div className="text-center py-20 md:py-28 max-w-xl">
          <span className="font-heading text-6xl md:text-8xl font-bold text-background-300">404</span>
          <h1 className="mt-6 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            这一页的瓜还没长出来
          </h1>
          <p className="mt-3 text-sm text-foreground-600 leading-7">
            你访问的地址不存在或内容已下架。回首页看看今天上新了什么，或者去瓜料库按档期翻一翻。
          </p>
          <p className="mt-3 text-xs text-foreground-400 break-all">当前路径：{location.pathname}</p>
          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-home-5-line" aria-hidden="true"></i>
              返回首页
            </Link>
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-800 text-sm font-medium whitespace-nowrap hover:border-primary-300 hover:text-primary-600 transition-colors"
            >
              去瓜料库
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}